import request from '../request'

export const goodsApi = {
  // 获取所有商品
  getAllGoods () {
    return request.get('goods/getAllGoods')
  },

  // 按商品名称搜索
  searchByName (params) {
    return request.get('goods/searchByName', { params })
  },

  // 按品牌名称搜索
  searchByBrandName (params) {
    return request.get('goods/searchByBrandName', { params })
  },

  // 按属性搜索
  searchByProperty (params) {
    return request.get('goods/searchByProperty', { params })
  },

  // 搜索建议
  getSearchSuggestion (params) {
    return request.get('goods/searchSuggestion', { params })
  },

  // 保存商品
  saveGoods (data) {
    return request.post('goods/save', data)
  },

  // 更新商品
  updateGoods (data) {
    return request.post('goods/update', data)
  },

  // 删除商品
  deleteGoods (id) {
    return request.delete(`goods/delete/${id}`)
  },

  // 获取商品详情
  getGoodsDetail (id) {
    return request.get(`goods/detail/${id}`)
  },

  // 上传文件
  uploadFile (file) {
    const formData = new FormData()
    formData.append('multipartFiles', file)
    return request.post('goods/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  // 下载所有商品
  downloadAllGoods () {
    return request.post('goods/downLoadAllGoods', null, {
      responseType: 'blob'
    })
  },

  // 获取商品属性
  getProperty () {
    return request.get('property/get')
  },

  // 根据ID获取商品
  getById (id) {
    return request.get('goods/getById', { params: { id } })
  },

  // 根据状态获取商品
  getByState (state) {
    return request.get('goods/getByState', { params: { state } })
  },

  // 删除商品
  deleteById (id) {
    return request.get('goods/deleteById', { params: { id } })
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/goods.js